if (!window.Eurus) window.Eurus = { loadedScript: [] };
if (!window.Eurus.loadedScript) window.Eurus.loadedScript = [];

if (!window.Eurus.loadedScript.includes("quantity-offer-selector.js")) {
  window.Eurus.loadedScript.push("quantity-offer-selector.js");

  const formatWithDelimiters = (number, precision, thousands, decimal) => {
    thousands = thousands === undefined ? "," : thousands;
    decimal = decimal === undefined ? "." : decimal;
    if (isNaN(number) || number == null) return "0";
    const parts = (number / 100.0).toFixed(precision).split(".");
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
    return parts[1] ? dollars + decimal + parts[1] : dollars;
  };

  const formatMoney = (cents, formatString) => {
    const format = formatString || "{{amount}}";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = format.match(placeholderRegex);
    if (!match) return String((cents / 100).toFixed(2));
    let value;
    switch (match[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      case "amount_with_apostrophe_separator":
        value = formatWithDelimiters(cents, 2, "'", ".");
        break;
      case "amount_with_space_separator":
        value = formatWithDelimiters(cents, 2, " ", ".");
        break;
      case "amount_no_decimals_with_space_separator":
        value = formatWithDelimiters(cents, 0, " ", ".");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return format.replace(placeholderRegex, value);
  };

  const offerRate = (type, qty) => {
    if (type === "combo") return 0.14;
    if (type === "triple") return 0.17;
    if (qty >= 3) return 0.15;
    if (qty === 2) return 0.125;
    return 0.1;
  };

  const applyOfferToRoot = (root, qty) => {
    if (!root) return;
    const type = root.getAttribute("data-navdhan-offer");
    const unit = Number(root.getAttribute("data-navdhan-unit-cents"));
    const moneyFormat = root.getAttribute("data-navdhan-money-format") || "{{amount}}";
    if (!type || !Number.isFinite(unit)) return;
    const rate = offerRate(type, qty);
    const sale = Math.round(unit * (1 - rate));
    const percent = rate * 100;
    const saveLabel = Number.isInteger(percent) ? `${percent}%` : `${percent}%`;
    const saleEl = root.querySelector(".navdhan-offer-sale");
    const compareEl = root.querySelector(".navdhan-offer-compare");
    const saveEl = root.querySelector(".navdhan-offer-save");
    if (saleEl) saleEl.textContent = formatMoney(sale, moneyFormat);
    if (compareEl) compareEl.textContent = formatMoney(unit, moneyFormat);
    if (saveEl) saveEl.textContent = `Save ${saveLabel}`;
  };

  const updatePdpOfferPrices = (sectionId, qty) => {
    const nextQty = Number(qty) || 1;
    const roots = document.querySelectorAll(
      `#price-${sectionId} [data-navdhan-offer], #price-sticky-${sectionId} [data-navdhan-offer], .price-sticky-${sectionId} [data-navdhan-offer]`
    );
    roots.forEach((root) => applyOfferToRoot(root, nextQty));
  };

  window.NavdhanOfferPrice = { updatePdpOfferPrices };

  const register = () => {
    if (window.__navdhanQuantityOfferRegistered || !window.Alpine) return;
    window.__navdhanQuantityOfferRegistered = true;

    Alpine.data("xQuantityOfferSelector", (config) => ({
      qty: Number(config.min) || 1,
      min: Number(config.min) || 1,
      max: config.max === null || config.max === undefined ? null : Number(config.max),
      increment: Number(config.increment) || 1,
      sectionId: config.sectionId,
      stickyId: config.stickyId,
      showPlusTiers: (Number(config.min) || 1) >= 3,
      syncing: false,

      init() {
        this.showPlusTiers = this.qty >= 3;
        this.publishOffer();
        this.$watch("qty", (value) => {
          const next = this.normalize(value);
          if (next !== this.qty) {
            this.qty = next;
            return;
          }
          this.showPlusTiers = next >= 3;
          this.syncSticky(next);
          this.publishOffer();
        });

        document.addEventListener(`eurus:product-page-variant-select:updated:${this.sectionId}`, () => {
          this.$nextTick(() => {
            const input = this.quantityInput();
            if (input && Number(input.value) !== Number(this.qty)) {
              input.value = this.qty;
            }
            this.publishOffer();
          });
        });
      },

      publishOffer() {
        updatePdpOfferPrices(this.sectionId, this.qty);
      },

      quantityInput() {
        return document.getElementById(`Quantity-${this.sectionId}`);
      },

      normalize(value) {
        let next = parseInt(value, 10);
        if (!Number.isInteger(next) || next < this.min) next = this.min;
        if (this.max !== null && next > this.max) next = this.max;
        return next;
      },

      minus(step) {
        this.qty = this.normalize(this.qty - step);
      },

      plus(step) {
        this.qty = this.normalize(this.qty + step);
      },

      invalid(el) {
        this.qty = this.normalize(el.value);
      },

      primaryTier() {
        if (this.qty === 1) return 1;
        if (this.qty === 2) return 2;
        if (this.qty === 3 || this.qty > 6) return 3;
        return null;
      },

      plusLabel() {
        return this.qty === 3 ? "Buy 3" : "Buy 3 or more";
      },

      subTier() {
        if (this.qty === 4 || this.qty === 5 || this.qty === 6) return this.qty;
        return null;
      },

      discountLabel() {
        if (this.qty >= 3) return "15% OFF";
        if (this.qty === 2) return "12.5% OFF";
        return "10% OFF";
      },

      selectPrimary(tier) {
        if (tier === 1) {
          this.showPlusTiers = false;
          this.qty = 1;
          return;
        }
        if (tier === 2) {
          this.showPlusTiers = false;
          this.qty = 2;
          return;
        }
        this.showPlusTiers = true;
        this.qty = 3;
      },

      selectSub(quantity) {
        this.showPlusTiers = true;
        this.qty = this.normalize(quantity);
      },

      syncSticky(quantity) {
        if (!this.stickyId || this.syncing) return;
        const sticky = document.getElementById(this.stickyId);
        if (!sticky || Number(sticky.value) === Number(quantity)) return;
        this.syncing = true;
        sticky.value = quantity;
        sticky.dispatchEvent(new Event("input", { bubbles: true }));
        this.syncing = false;
      },
    }));
  };

  document.addEventListener("alpine:init", register);
  if (window.Alpine) register();
}
